export const SET_CRITERE_PLANNING = 'SET_CRITERE_PLANNING';
export const SET_PANNEAUX = 'SET_PANNEAUX';
export const SET_PANNEAUX_WITH_FILTER = 'SET_PANNEAUX_WITH_FILTER';
export const SET_SHOW_PANNEAUX = 'SET_SHOW_PANNEAUX';
export const SET_DATE_START = 'SET_DATE_START';
export const SET_DATE_END = 'SET_DATE_END';
export const SET_FILTER_ADDRESS = 'SET_FILTER_ADDRESS';
export const SET_FILTER_RAYON = 'SET_FILTER_RAYON';
export const SET_ISOCHRONE = 'SET_ISOCHRONE';
export const SET_TYPE_LAYER_GEO_MARKETING = 'SET_TYPE_LAYER_GEO_MARKETING';
export const SET_AFFICHAGE_CERCLE = 'SET_AFFICHAGE_CERCLE';
export const SET_ZOOM_CARTO = 'SET_ZOOM_CARTO';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const ADD_FILTER_PROPERTY = 'ADD_FILTER_PROPERTY';
export const REMOVE_FILTER_PROPERTY = 'REMOVE_FILTER_PROPERTY';
export const ADD_FILTER_DYNAMIQUE = 'ADD_FILTER_DYNAMIQUE';
export const SELECT_FILTRE_DYNAMIQUE = 'SELECT_FILTRE_DYNAMIQUE';
export const TRIE_PANNEAUX = 'TRIE_PANNEAUX';
export const SET_FILTER_CHANGED = 'SET_FILTER_CHANGED';
export const SET_MARKER = 'SET_MARKER';
export const SET_SELECTED_MARKER = 'SET_SELECTED_MARKER';
export const SET_TYPE_VENTE = 'SET_TYPE_VENTE';
export const SET_PANNEAU_SELECTED = 'SET_PANNEAU_SELECTED';
export const SET_SHOW_PANNEAUX_SELECTIONNE = 'SET_SHOW_PANNEAUX_SELECTIONNE';
export const SET_POINTS_ADDRESS = 'SET_POINTS_ADDRESS';



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/venteNumerique-mutation-type.js